import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';

import Field, { hasDataInFields } from '../../Field';
import BlockContainer from '../BlockContainer';
import css from './BlockUserItem.module.css';

const SparkleIcon = ({ className }) => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" className={className}>
    <path d="M24 12C17.7782 12 12 17.7782 12 24C12 17.7782 6.22183 12 0 12C6.22183 12 12 6.22183 12 0C12 6.22183 17.7782 12 24 12Z" fill="#8C265C"/>
  </svg>
);

/**
 * User profile card for the users-carousel section.
 *
 * Data comes directly from the CMS block:
 *   media         → profile image (resolved imageAsset via Field)
 *   title.content → display name
 *   text.content  → user UUID or storeName (for profile link /u/{id})
 */
const BlockUserItem = props => {
  const {
    blockId,
    className,
    rootClassName,
    ctaButtonClass,
    title,
    text,
    media,
    responsiveImageSizes,
    options,
  } = props;

  const displayName = title?.content?.trim() || '';
  const userId = text?.content?.trim() || '';
  const hasMedia = hasDataInFields([media], options);

  if (!userId && !displayName) return null;

  const profilePath = userId ? `/u/${userId}` : null;

  return (
    <BlockContainer id={blockId} className={classNames(rootClassName || css.root, className)}>
      <div className={css.mediaWrapper}>
        <div className={css.media}>
          {hasMedia ? (
            <Field
              data={media}
              sizes={responsiveImageSizes || '(max-width: 767px) 100vw, 400px'}
              options={options}
            />
          ) : (
            <div className={css.placeholder} aria-hidden="true" />
          )}
        </div>
        <SparkleIcon className={css.sparkleLeft} />
        <SparkleIcon className={css.sparkleRight} />
      </div>

      {displayName ? (
        <div className={css.nameGroup}>
          <span className={css.name}>{displayName}</span>
        </div>
      ) : null}

      {profilePath ? (
        <Link to={profilePath} className={ctaButtonClass || css.ctaLink}>
          Ver closet
        </Link>
      ) : null}
    </BlockContainer>
  );
};

export default BlockUserItem;
